$('.hpe-disclosure__button[data-disclosure]').click(function () {
  const selectedSection = $(this).attr('data-disclosure');
  const disclosureSection = $(
    `.hpe-disclosure__section[data-disclosure-section='${selectedSection}']`
  );
  const hidden = disclosureSection.attr('aria-hidden') !== 'true';

  if (hidden) {
    disclosureSection.attr('aria-hidden', true);
  } else {
    disclosureSection.attr('aria-hidden', false);
  }

  $(this).toggleClass('hpe-disclosure__button--active');
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/disclosure.js